// FixLocalTesting v1.3
// Rewrites localhost URLs to the current LAN hostname during local network testing.

// changelog:
// 1.0 initial version, handles anchors, forms, img lazy attributes, global JS vars
// 1.1 expand IP check to all RFC 1918 ranges (10.*, 172.16-31.*, 192.168.*), add source element handling
// 1.2 add data-src-mobile and data-srcset-mobile handling for img and video elements
// 1.3 add $homeUrl rewrite 

export const fixLocalTesting = () => {
  const hostname = window.location.hostname;
  // matches all RFC 1918 private IP ranges: 10.*, 172.16-31.*, 192.168.*
  if (!/^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(hostname)) return;

  // replace in links
  const anchors = document.querySelectorAll('a');
  anchors.forEach(element => {
    const href = element.getAttribute('href');
    if (!href) return;
    element.setAttribute('href', href.replace('localhost', hostname));
  });

  // replace in forms
  const forms = document.querySelectorAll('form');
  forms.forEach(element => {
    const action = element.getAttribute('action');
    if (!action) return;
    element.setAttribute('action', action.replace('localhost', hostname));
  });

  // replace in image lazy attributes
  const imageEls = document.querySelectorAll('img');
  imageEls.forEach(imageEl => {
    const src = imageEl.getAttribute('data-src');
    if (src) imageEl.setAttribute('data-src', src.split('localhost').join(hostname));

    const srcMobile = imageEl.getAttribute('data-src-mobile');
    if (srcMobile) imageEl.setAttribute('data-src-mobile', srcMobile.split('localhost').join(hostname));

    const srcset = imageEl.getAttribute('data-srcset');
    if (srcset) imageEl.setAttribute('data-srcset', srcset.split('localhost').join(hostname));

    const srcsetMobile = imageEl.getAttribute('data-srcset-mobile');
    if (srcsetMobile) imageEl.setAttribute('data-srcset-mobile', srcsetMobile.split('localhost').join(hostname));
  });

  // replace in video lazy attributes
  const videoEls = document.querySelectorAll('video');
  videoEls.forEach(videoEl => {
    const src = videoEl.getAttribute('data-src');
    if (src) videoEl.setAttribute('data-src', src.split('localhost').join(hostname));

    const srcMobile = videoEl.getAttribute('data-src-mobile');
    if (srcMobile) videoEl.setAttribute('data-src-mobile', srcMobile.split('localhost').join(hostname));
  });

  // replace in source elements (picture, video)
  const sourceEls = document.querySelectorAll('source');
  sourceEls.forEach(sourceEl => {
    const src = sourceEl.getAttribute('src');
    if (src) sourceEl.setAttribute('src', src.split('localhost').join(hostname));

    const srcset = sourceEl.getAttribute('srcset');
    if (srcset) sourceEl.setAttribute('srcset', srcset.split('localhost').join(hostname));
  });

  if (typeof $baseUrl !== 'undefined') $baseUrl = $baseUrl.replace('localhost', hostname);
  if (typeof $url !== 'undefined') $url = $url.replace('localhost', hostname);
  if (typeof $homeUrl !== 'undefined') $homeUrl = $homeUrl.replace('localhost', hostname);
  if (typeof $assets !== 'undefined') $assets = $assets.replace('localhost', hostname);
};
